// Location attachments can be documents (PDF, Excel, Word…) as well as
// photos. Each item is either a browser File (picked, not uploaded yet) or
// the upload metadata stored on the location.

const IMAGE_EXTS = ["jpg", "jpeg", "png", "gif", "webp", "heic", "heif", "bmp"];

const isFile = (item) => typeof File !== "undefined" && item instanceof File;

export const attachmentName = (item) =>
  (isFile(item) ? item.name : item?.originalname || item?.filename) || "";

export const attachmentExtension = (item) => {
  const source = attachmentName(item) || item?.destination || "";
  const last = source.split("?")[0].split("/").pop() || "";
  const dot = last.lastIndexOf(".");
  return dot > 0 ? last.slice(dot + 1).toLowerCase() : "";
};

export const isImageAttachment = (item) => {
  const type = isFile(item) ? item.type : item?.mimetype;
  if (type) return type.startsWith("image/");
  return IMAGE_EXTS.includes(attachmentExtension(item));
};

// Viewable URL for stored metadata. Uploads keep the full S3 URL in
// `location`/`destination`; very old local uploads stored a relative folder
// plus filename.
export const resolveAttachmentUrl = (item) => {
  if (!item) return "";
  if (isFile(item)) return URL.createObjectURL(item);
  if (/^https?:\/\//i.test(item.location || "")) return item.location;
  if (/^https?:\/\//i.test(item.destination || "")) return item.destination;
  if (item.destination && item.filename) {
    return `${process.env.REACT_APP_IMAGE_URL}/${item.destination}${item.filename}`;
  }
  return "";
};

// react-dropzone `accept`: images plus the document types the backend's
// upload allowlist (config/storage.js) takes.
export const ATTACHMENT_ACCEPT = {
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/gif": [".gif"],
  "image/webp": [".webp"],
  "application/pdf": [".pdf"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "text/csv": [".csv"],
};

// Contact Us attachments: the same list the mobile Contact Us screen offers
// (CONTACT_DOCUMENT_TYPES in teamplayer/app/screens/contact-us.tsx). Used as
// a plain <input accept> string, and to re-check what was picked.
export const CONTACT_ATTACHMENT_EXTS = [
  "jpg",
  "jpeg",
  "png",
  "heic",
  "webp",
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "txt",
  "csv",
];
export const CONTACT_ATTACHMENT_ACCEPT = CONTACT_ATTACHMENT_EXTS.map(
  (ext) => `.${ext}`,
).join(",");
export const CONTACT_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024; // matches the backend upload cap
